<template>
  <div v-if="error && error.length" class="alert alert-sm alert-error-secondary" v-html="error"></div>
</template>

<script>
export default {
  name: 'CheckOutFormError',
  props: ['error']
}
</script>
